import script from "./OfferClosedView.vue?vue&type=script&setup=true&lang=js"
export * from "./OfferClosedView.vue?vue&type=script&setup=true&lang=js"

import "./OfferClosedView.vue?vue&type=style&index=0&id=0eac696e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0eac696e"]])

export default __exports__